/**
 * Central environment configuration for the control panel.
 *
 * All environment-specific values are build-time env vars (REACT_APP_*), inlined by
 * CRA at `yarn build`. Each falls back to the current production value, so a plain
 * `build` (no env) produces the unchanged prod bundle; `build:dev` (env-cmd -f .env.dev)
 * overrides them to the dev environment (project mchosts-req-dev, domain pinti.family).
 *
 * These are NOT secrets - the control panel is a public client bundle, so the Firebase
 * web config and hostnames ship to the browser and are inherently public.
 */

export const FIREBASE_CONFIG = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY ?? "AIzaSyBmWi6ZYsuTNwjl7siHBS0iMZMfjfsRCI4",
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN ?? "mchosts-req.firebaseapp.com",
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID ?? "mchosts-req",
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET ?? "mchosts-req.appspot.com",
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID ?? "188102117197",
  appId: process.env.REACT_APP_FIREBASE_APP_ID ?? "1:188102117197:web:2cd3f1a69b2e73c596d904",
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID ?? "G-B3DZT4R0ZT",
};

// Per-server MC address suffix (dev: pinti.family).
export const SERVER_DOMAIN = process.env.REACT_APP_SERVER_DOMAIN ?? "mchosts.co";

// MCProxy WebSocket host (console / files / stats).
export const WS_HOST = process.env.REACT_APP_WS_HOST ?? "ws.mchosts.com.au";

// MCProxy REST API base URL.
export const MCPROXY_URL = process.env.REACT_APP_MCPROXY_URL ?? "https://api.mchosts.com.au";

// SFTP gateway host (shown to the user).
export const SFTP_HOST = process.env.REACT_APP_SFTP_HOST ?? "sftp.mchosts.com.au";

// MariaDB / phpMyAdmin host (shown to the user).
export const DB_HOST = process.env.REACT_APP_DB_HOST ?? "db.mchosts.com.au";

// Web-services (map/dynmap etc.) public host.
export const WEB_SERVICES_HOST = process.env.REACT_APP_WEB_SERVICES_HOST ?? "play.mchosts.com.au";

// Voice-chat public host.
// VOICE_HOST (REACT_APP_VOICE_HOST) was removed 2026-09-14: voice chat now
// uses the server's own MCHosts hostname, written by VoiceChatSection.tsx.
// See PLAN_NODE_LOCAL_ROUTING.md Phase 2b.

// The marketing site, for links out to the free tools. Deliberately the live
// site even on dev: there is no dev copy of the seed map, and panel links must
// never point at the dev domain.
export const STORE_URL = process.env.REACT_APP_STORE_URL ?? "https://mchosts.com.au";

/** Strip the per-server domain suffix from a full MC address to get the subdomain label. */
export const stripServerDomain = (mcAddress: string): string =>
  mcAddress.replace("." + SERVER_DOMAIN, "");
